import { StyledComponentsSectionProps } from 'components/general-styles';
import styled from 'styled-components';

export const Loading = styled.section<StyledComponentsSectionProps>`
  display: flex;
  width: 100%;
  margin: 32px 0;
  opacity: 0.3;
`;
